<tt-page *ngIf="!!edit">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input ttLabel="skillscertificatetype_keyno" [ttModel]="edit.skillscertificatetype_keyno" ttReadonly></tt-input>
        <tt-input ttLabel="skillscertificatetype_name" [(ttModel)]="edit.skillscertificatetype_name" ttRequired></tt-input>
        <tt-input ttLabel="skillscertificatetype_shortname" [(ttModel)]="edit.skillscertificatetype_shortname" ttRequired></tt-input>
        <tt-textarea ttLabel="note" [(ttModel)]="edit.note"></tt-textarea>
        <tt-input ttLabel="order" [ttModel]="edit.order" ttReadonly></tt-input>
        <tt-select ttLabel="glyphicon" [(ttModel)]="edit.glyphicon" (ttModelChange)="onChanged($event, 'glyphicon')" [ttData]="selectListGlyphicons" ttDataId="item_id" ttDataName="item_name" [ttButtons]="glyphiconButtons"></tt-select>

        <div *ngIf="edit.glyphicon.startsWith('fa-')">
            <pre><span class="fa" [ngClass]="edit.glyphicon" [style.font-size.px]="40" [style.color]="edit.glyphicon_color"></span></pre>
        </div>

        <div *ngIf="edit.glyphicon.startsWith('fab-')">
            <pre><span class="fab" [ngClass]="'fa-' + edit.glyphicon.slice(4)" [style.font-size.px]="40" [style.color]="edit.glyphicon_color"></span></pre>
        </div>

        <div *ngIf="edit.glyphicon.startsWith('fad-')">
            <pre><span class="fad" [ngClass]="'fa-' + edit.glyphicon.slice(4)" [style.font-size.px]="40" [style.color]="edit.glyphicon_color"></span></pre>
        </div>

        <div *ngIf="edit.glyphicon.startsWith('far-')">
            <pre><span class="far" [ngClass]="'fa-' + edit.glyphicon.slice(4)" [style.font-size.px]="40" [style.color]="edit.glyphicon_color"></span></pre>
        </div>

        <div *ngIf="edit.glyphicon.startsWith('fas-')">
            <pre><span class="fas" [ngClass]="'fa-' + edit.glyphicon.slice(4)" [style.font-size.px]="40" [style.color]="edit.glyphicon_color"></span></pre>
        </div>

        <div *ngIf="edit.glyphicon.startsWith('glyphicon-')">
            <pre><span class="glyphicon" [ngClass]="edit.glyphicon" [style.font-size.px]="40" [style.color]="edit.glyphicon_color"></span></pre>
        </div>

        <tt-select ttLabel="glyphicon_color" [(ttModel)]="edit.glyphicon_color" (ttModelChange)="onChanged($event, 'glyphicon_color')" [ttData]="selectListHexColours" ttDataId="hexcolor" ttDataName="color_name"></tt-select>
        <tt-button-save ttText="skillscertificatetype_save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
    </tt-card>
</tt-page>
